import React from 'react'

const RedioText = ({ field, handleChange })=>  {

    return (
        <div className={field.colunms}>
                      <div className="form-group ">
                       {field?.heading &&  <h6>  {field?.heading} </h6>}
                      <label>{field?.label} {field?.required ? <span>*</span> : ''} </label>
                      <div className="radio-group">
                      {
                            field.options.map ( (option ,idx)=> {
                                return  <>
                                   <label key={idx} htmlFor={option.value} className="radio-label">
                                    <input
                                      id={option.value} 
                                      type={field?.type}
                                      name={field?.name}
                                      value={option?.value}
                                      onChange={handleChange}
                                    />
                                    <span>  {option?.label} </span>
                                  </label>
                                </> 
                            })
                          }
                      </div>
                   
            </div>
        </div>
    )
}

export default RedioText;
